import React    from "react";
import './TnCongrats.css'
import {Button} from "antd";
import Header from "../../../components/header/Header";
import Phone from "../../../assets/logo/phone.png";

export default function TnCongrats(){
    return(
        <>
            <div style={{backgroundColor:"#E6E6E6",width:"100%"}}>
                <Header/>
            </div>
            <div className="congratsDiv">
                <img src={Phone} alt="Phone with SMS AlertPop"/>
                <h3>
                    Congratulations
                </h3>
                <div className="congrats">
                    The request is being processed. Please pay attention to your SMS notifications.
                </div>
                <Button
                    className="mainButton"
                    type="primary"
                    shape="round"
                    style={{ backgroundColor: "#f13434"}}
                    // onClick={handleController}
                >
                    DONE
                </Button>
            </div>
        </>
    )
}